import React, { useEffect, useState } from "react";

import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import store from "../../../store/store";
import InfoBox from "../InfoBox/InfoBox";

import modalInfo from "../../../assets/img/common/modal_info.svg";

import { playAudioEffect } from "../../../store/audio-slice";
import { AudioEnum } from "../../../enums";
import BetWon from "./BetOutcome/BetWon";
import BetLost from "./BetOutcome/BetLost";

interface IModalMessage {
  message: string;
  onApprove?(): void;
  onReject?(): void;
  className?: string;
  winAmount?: number;
}

const ModalMessage: React.FC<IModalMessage> = ({
  message,
  onApprove,
  onReject,
  className,
  winAmount = 0,
}) => {
  const { t } = useTranslation();
  const winningNumber = useAppSelector((state) => state.wheel.winningNumber);
  const [messageForModal, setMessageForModal] = useState(message);
  const dispatch = useAppDispatch();

  useEffect(() => {
    let timeout: NodeJS.Timeout | null = null;

    if (messageForModal.includes("ticketTerminated")) {
      timeout = setTimeout(() => {
        setMessageForModal("message.bettingDisabled");
      }, 5000);
    } else if (timeout) {
      clearTimeout(timeout);
    }

    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [messageForModal]);

  let maxStakeReachedValue = "";
  if (messageForModal === "message.maxStakeReached") {
    maxStakeReachedValue = ` ${(
      store.getState().config.maxLocationStake / 100
    ).toString()}`;
  }

  let closeModal: JSX.Element = <></>;

  if (onApprove) {
    if (onReject) {
      closeModal = (
        <>
          <button type="button" className="btn green" onClick={onApprove}>
            {t("message.audio.yes")}
          </button>
          <button type="button" className="btn green" onClick={onReject}>
            {t("message.audio.no")}
          </button>
        </>
      );
    } else {
      closeModal = (
        <button
          type="button"
          className={`btn ${
            messageForModal === "message.betterLuck" ? "red" : "green"
          }`}
          onClick={() => {
            onApprove();
            dispatch(playAudioEffect(AudioEnum.EFFECT_MODAL_OK));
          }}
        >
          OK
        </button>
      );
    }
  }

  return createPortal(
    <div className="backdrop">
      <div className={`modal_container ${className}`}>
        <div className="modal_title">
          <img src={modalInfo} alt="" />
          Info
        </div>
        <div className="modal_content">
          <div className="modal_content_container">
            {winAmount > 0 && (
              <BetWon winAmount={winAmount} winningNumber={winningNumber} />
            )}
            {winAmount <= 0 && <BetLost messageForModal={messageForModal} />}
          </div>
          {winAmount > 0 && (
            <InfoBox
              title="panel.common.yourPick"
              content={store
                .getState()
                .picks.pickedStakes.map((el) => el.value)}
              shouldShow
            />
          )}
          <p>
            {t(messageForModal)}
            {maxStakeReachedValue}
          </p>
          {onApprove && closeModal}
        </div>
      </div>
    </div>,
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    document.getElementById("overlay-root")!
  );
};

ModalMessage.defaultProps = {
  className: "",
};

export default ModalMessage;
